export default "__VITE_ASSET__D$l2M1IR__"